// @auto-index

import covers from './covers'
import Education from './Education'
import Interests from './Interests'
import Notes from './Notes'
import Profile from './Profile'
import Projects from './Projects'
import Skills from './Skills'

export { default as covers } from './covers'
export { default as Education } from './Education'
export { default as Interests } from './Interests'
export { default as Notes } from './Notes'
export { default as Profile } from './Profile'
export { default as Projects } from './Projects'
export { default as Skills } from './Skills'

export default {
  covers,
  Education,
  Interests,
  Notes,
  Profile,
  Projects,
  Skills
}
